import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    emailRecipient(context, recipient) {
      //axios.post('http://stop-the-spread.test/api/test-access', {data: 'exists'});
      axios.post('http://stop-the-spread.test/api/new-message-received', recipient)
    }
  },
  modules: {
  }
})
